import { camel } from 'change-case'
import { api } from '../../libs/api'
import {
  acquisitionDates,
  postingSituations,
  salaryTypes,
} from '../../constants'

export default {
  namespaced: true,

  state: {
    loaded: false,
    articlePlans: [],
    cities: [],
    industries: [],
    jobtypeClasses: [],
    jobtypes: [],
    mediaForJobs: [],
    media: [],
    prPoints: [],
    prefectures: [],
    acquisitionDates,
    postingSituations,
    salaryTypes,
    employments: [],
    salesStatuses: [],
    startingBusinessIndustryMajorClasses: [],
    genre: [],
    startingBusinessPrefectures: [],
  },
  getters: {
    translate: state => (master, passedCode) => {
      const found = state[master].find(({ code }) => code === passedCode)
      return found
        ? found.name
        : 'not matched'
    },
    // arrow style の片方に対応すると片方にひっかかるため
    /* eslint-disable */
    translateList: (state, getters) => (master, codes) =>
      Array.isArray(codes)
        ? codes.map(code => getters.translate(master, code))
        : []
    ,
    /* eslint-enable */
  },
  mutations: {
    loaded: state => state.loaded = true,
    masterData: (state, masterData) => {
      Object.keys(masterData).forEach((key) => {
        const variableName = camel(key)
        state[variableName] = masterData[key]
      })
    },
  },
  actions: {
    async fetch ({ commit, state }) {
      if (state.loaded) {
        return Promise.resolve()
      }

      try {
        const response = await api.fetchMaster()
        commit('masterData', response)
        commit('loaded')
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/master.js